import { useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { SaveButton } from '@ui/actions'
import { DefaultValues, WallRipConfig } from '../../types'

interface Props {
  loading: boolean
}

const CustomSubmitButton = ({ loading }: Props) => {
  const config = useWatch<DefaultValues>({ name: 'config' }) as WallRipConfig
  const useRelativePosition = useWatch<DefaultValues>({ name: 'useRelativePosition' })
  const usePointPosition = useWatch<DefaultValues>({ name: 'usePointPosition' })
  const ripCreationMode = useWatch<DefaultValues>({ name: 'ripCreationMode' })
  const copyRipsOriginWall = useWatch<DefaultValues>({ name: 'copyRipsOriginWall' })

  const hasRipsToCreate = useMemo(() => {
    if (ripCreationMode === 'copyRips' && copyRipsOriginWall) return true
    const hasStartOrEnd = Object.values(config).some(c => {
      return (c.start && !c.startLocked) || (c.end && !c.endLocked)
    })
    return hasStartOrEnd || useRelativePosition || usePointPosition
  }, [config, useRelativePosition, usePointPosition, ripCreationMode, copyRipsOriginWall])

  return (
    <SaveButton
      loading={loading}
      disabled={!hasRipsToCreate}
      size="small"
      fullWidth={true}
      type="submit"
      data-cy="multi-edit-wall-rips-edges-submit-button"
    >
      Rippen hinzufügen
    </SaveButton>
  )
}

export default CustomSubmitButton
